import GroupMembers from './GroupMembers.component';

export default GroupMembers;
